﻿window.cObjetCompteClientUtilisateurMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "utilisateur compte client"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau utilisateur compte client"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') {
            if (objet.data.nom == null) { txt = "" }
            else { txt = objet.data.nom }
            if (objet.data.prenom != null) { txt += ((txt.length > 0) ? "/" : "") + objet.data.prenom }
            if (txt.length == 0) txt = objet.data.adresse_email
        }
        else {
            txt = "utilisateur compte client"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetLibNomPrenomFromDataTemplate = function (dataTemplate) {
        var txt = ""
        var objCptCli = Me.objet.bddRef.getObjet("compte_client")
        var nomStr = objCptCli.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate)
        var txt = "";
        if (dataTemplate.con_nom != null && dataTemplate.con_nom.length > 0) txt += dataTemplate.con_nom.toUpperCase();
        if (dataTemplate.con_prenom != null && dataTemplate.con_prenom.length > 0) {
            if (txt.length > 0) txt += " ";
            txt += dataTemplate.con_prenom;
        }
        return nomStr + "/" + txt
    }

    this.mGetNom = function () {
        var txt = ""
        if (objet.data.nom == null) { txt = "" } else { txt = objet.data.nom }
        var nomPrenom = ""
        if (objet.data.nom_contact != null) { nomPrenom += objet.data.nom_contact }
        if (objet.data.prenom_contact != null) { nomPrenom += ((nomPrenom.length > 0) ? " " : "") + objet.data.prenom_contact }
        if (nomPrenom.length > 0) txt += ((txt.length > 0) ? "/" : "") + nomPrenom
        return txt
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        if (typeof objet.data != 'undefined') {
            if (typeof objet.data.nom != 'undefined' && objet.data.nom != null && objet.data.nom.length > 0) { txt += objet.data.nom[0] }
            if (typeof objet.data.prenom != 'undefined' && objet.data.prenom != null && objet.data.prenom.length > 0) { txt += objet.data.prenom[0] }
            else { if (typeof objet.data.nom != 'undefined' && objet.data.nom != null && objet.data.nom.length > 1) txt += objet.data.nom[1] }
        }
        return txt.toUpperCase();
    }

    this.mGetIcone = function ($Icone) {
        var ele = $("<i class='fas fa-address-card' style='position:relative'><i class='fas fa-child' style='position:absolute;bottom:-2px;right:-2px;opacity:1;font-size:65%;color:" + theme.backgroundcolorAccent + "'></i></i>");
        ele.attr("title", "Compe client utilisateur")
        return ele
    }

    this.mGetImageData = function (opt) {
        opt.bddCtrl = Me.objet.bddRef
        opt.data = objet.data
        opt.data2 = this.mGetDataCompteClient()
        return $("<div/>").dxCtrlImageData(opt).dxCtrlImageData("instance")
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    this.hasScrollPopup = function () { return false }
    this.contentTemplateSaisie = function (contentElement, option) {
        contentElement.css("padding", "0 20px 20px 20px")
        var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Adresse email'>Adresse email</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + objet.data.adresse_email + "</td>").appendTo($Tr)

        var dataCompteClient = this.mGetDataCompteClient()
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Nom de la base de données'>Environnement</td>").appendTo($Tr)
        if (typeof dataCompteClient.nom_base == 'undefined' || dataCompteClient.nom_base == null) {
            var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>(aucun)</td>").appendTo($Tr)
        } else {
            var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'></td>").appendTo($Tr)
            var $AEnvironnement = $("<a href='javascript:void(0)' target='_blank'>" + dataCompteClient.nom_base + "</a>").appendTo($Td)
            $AEnvironnement.on("click", function (e) {
                e.preventDefault();
                tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: $AEnvironnement,
                    showCloseButton: false,
                    position: "bottom",
                    contentTemplate: function (contentElement) {
                        $("<div style='padding-bottom:10px;'>Se connecter avec l'utilisateur<br/>sur l'environnement.</div>").appendTo(contentElement)
                        $("<div/>").appendTo(contentElement).dxCtrlButton({
                            text: objet.data.adresse_email,
                            width: '100%',
                            onClick: function (e) {
                                tt.hide();
                                jaugeDemarrage.mShow()
                                Me.objet.bddRef.mAjaxCall({ command: "connectbasewithutilisateur", email: objet.data.adresse_email, nombase: dataCompteClient.nom_base },
                                    function (data) {
                                        if (data.resultat == "ok") {
                                            forcerFermetureNavigateur = true
                                            window.location.reload()
                                        }
                                        else { mNotify("Impossible de se connecter au client.", "error", 4000); pageJauge.mHide(50) }
                                    },
                                    function () {
                                    },
                                    function () {
                                        mNotify("Impossible de se connecter au client.", "error", 4000);
                                        jaugeDemarrage.mHide()
                                    })
                            }
                        });
                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            })
        }

        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Administrateur'>Administrateur</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + ((objet.data.administrateur == "1") ? "OUI" : "NON") + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Super administrateur'>Super administrateur</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + ((objet.data.super_administrateur == "1") ? "OUI" : "NON") + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Nom'>Nom</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + objet.data.nom + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Prénom'>Prénom</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + objet.data.prenom + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Téléphone'>Téléphone</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + ((objet.data.tel_sms) ? objet.data.tel_sms : "(aucun)") + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Mobile'>Mobile</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + ((objet.data.mob_sms) ? objet.data.mob_sms : "(aucun)") + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Date abandon'>Date abandon</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + ((objet.data.date_abandon) ? objet.data.date_abandon.toFrenchDateTime() : "") + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Fonction'>Fonction</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + ((objet.data.fonction) ? objet.data.fonction : "(aucune)") + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Dernière connexion'>Dernière connexion</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + ((objet.data.derniere_date_connexion) ? objet.data.derniere_date_connexion.toFrenchDateTime() + " (" + objet.data.derniere_date_connexion.toDateIlya() + ")" : "(aucune connexion)") + "</td>").appendTo($Tr)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Fin abonnement'>Fin abonnement</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'></td>").appendTo($Tr)
        var $A = $("<a href='javascript:void(0)' title='Modifier la date de fin d'abonnement'>" + ((objet.data.date_fin_abonnement) ? objet.data.date_fin_abonnement.toFrenchDateTime() + " (" + objet.data.date_fin_abonnement.toDateIlya() + ")" : "(aucun abonnement)") + "</a>").appendTo($Td)

        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text'>Dossier</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'></td>").appendTo($Tr)
        //$("<div class='dossier'/>").appendTo($Td).dxCtrlTagBoxDossier({
        //    bddCtrl: Me.objet.bddRef,
        //    labelMode: 'floating',
        //    label: "Dossier",
        //    id_table: objet.mGetTable().id_table,
        //    id: objet.cle(),
        //    onValueChanged: function (e) {
        //    }
        //}).dxCtrlTagBoxDossier("instance");

        $A.on("click", function () {
            popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                width: 300,
                height: "auto",
                showTitle: true,
                showMaximize: false,
                title: "Changer date fin abonnement",
                contentTemplate: function (contentElement) {
                    $("<div>L'abonnement expirera à 23h59m59s le soir de la date saisie</div>")
                    var $BoxDat = $("<div/>").appendTo(contentElement).dxCtrlDateBox({
                        value: ((objet.data.date_fin_abonnement) ? objet.data.date_fin_abonnement : new Date()),
                        min: new Date()
                    }).dxCtrlDateBox("instance")

                    $("<div style='padding-top:10px'/>").appendTo(contentElement);
                    var $Table = $("<table/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($Table);
                    $("<td style='width:100%'/>").appendTo($Tr)
                    var $Td = $("<td style='width:1px;padding-right:5px' class='tdok'/>").appendTo($Tr)
                    var btOk = $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Valider",
                        focusStateEnabled: false,
                        onClick: function (e) {
                            var dat = $BoxDat.option("value")
                            dat = new Date(dat.getFullYear(), dat.getMonth(), dat.getDate(), 23, 59, 59)
                            objet.data.date_fin_abonnement = dat
                            objet.mSaveChamp("date_fin_abonnement")
                            $A.text(((objet.data.date_fin_abonnement) ? objet.data.date_fin_abonnement.toFrenchDateTime() + " (" + objet.data.date_fin_abonnement.toDateIlya() + ")" : "(aucun abonnement)"))
                            popup.hide();
                        }
                    }).dxCtrlButton("instance");
                    var $Td = $("<td style='width:1px' class='tdannuler'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: ((typeof textAnnuler == 'undefined') ? "Annuler" : textAnnuler),
                        focusStateEnabled: false,
                        onClick: function (e) { popup.hide() }
                    });
                }
            }).dxCtrlPopupBase("instance")
            popup.show();
        })
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:30%;white-space:nowrap;padding-right:5px;text-overflow:ellipsis;overflow:hidden;' class='dx-field-item-label-text' title='Date création'>Créé le</td>").appendTo($Tr)
        var $Td = $("<td style='width:70%;text-overflow:ellipsis;overflow:hidden;'>" + objet.data.dcr.toDateIlya() + " (" + objet.data.dcr.toFrenchDateTime() + ")</td>").appendTo($Tr)
    }

    this.mGetWidthPopup = function () { return 550 }
    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    if (typeof option.fullScreen == 'undefined') option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        $("<div/>").appendTo(contentElement).dxCtrlPopupFicheContactEtActivite({
            bddCtrl: Me.objet.bddRef,
            id_table_destinataire: objet.mGetTable().id_table,
            id_destinataire: objet.cle(),
            onSelectionChanged: option.onSelectionChanged,
            optionPopup: option,
            getUrl: function (funcOk) {
                objet.mGetDataTemplate([], function (dataTemplate) {
                    if (dataTemplate.site_web != null && dataTemplate.site_web.length > 0) { funcOk(dataTemplate.site_web) }
                    else { funcOk(objet.mGetLib1()) }
                })
            }
        })
        //contentElement.closest(".dx-scrollable").css("padding", "3px 5px 0 10px")
        //contentElement.dxCtrlPopupContentCompteClient({
        //    objet: objet,
        //    onSelectionChanged: option.onSelectionChanged
        //})
    }

    this.mGetChampTableDataUnitaire = function (chpTableData) {
        return null
    }

    this.mGetDataItemTemplate = function (funcOk) {
        var adr = ""
        var tel = ((objet.data.tel_sms == null) ? "" : objet.data.tel_sms)
        var mobile = ((objet.data.mob_sms == null) ? "" : objet.data.mob_sms)
        var email = ((objet.data.adresse_email == null) ? "" : objet.data.adresse_email)
        var site = ""
        funcOk({
            adr: adr,
            tel: tel,
            mobile: mobile,
            email: email,
            site: site
        })
    }
    //this.itemTemplateVirtualGridFixed = function (contentElement, option) {
    //    contentElement.empty()
    //    contentElement.css("font-size", "11px")
    //    if (typeof option == "undefined") option = {}
    //    if (typeof option.height == 'undefined') option.height = 80
    //    contentElement.css({ position: "relative" })
    //    var heightPhoto = 67
    //    var opt = {
    //        bddCtrl: Me.objet.bddRef,
    //        data: Me.data,
    //        //data2: Me.mGetDataCompteClient(),
    //        size: heightPhoto,
    //        searchStringImageWeb: "",
    //        allowClick: option.allowClickImage
    //    }
    //    //if (typeof option.onClickImage != 'undefined') opt.onClick = option.onClickImage
    //    var dxImageObjet = $("<div style='position:absolute;top:0;left:0;'/>").appendTo(contentElement).dxCtrlImageData(opt).dxCtrlImageData("instance")
    //    var $Div = $("<div style='width:calc(100% - " + (heightPhoto + 10) + "px);position:absolute;top:0;left:" + (heightPhoto + 10) + "px;' class='divtext'></div>").appendTo(contentElement)
    //    var $DivNom = $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:150%;font-variant:small-caps;font-weight:bold;'></div>").appendTo($Div)
    //    Me.mGetIcone().css({ "color": theme.backgroundcolorAccent, display: "inline-block", "margin-right": "2px", "font-size": "75%" }).appendTo($DivNom)
    //    $("<span>" + Me.mGetLib1() + "</span>").appendTo($DivNom)

    //    var adr = ((objet.data.nom == null) ? "" : objet.data.nom) & " " & ((objet.data.prenom == null) ? "" : objet.data.prenom)
    //    if (adr.length > 0) {
    //        var $DivAdr = $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'></div>").appendTo($Div)
    //        $("<span style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + adr + "</span>").appendTo($DivAdr)
    //    }

    //    var tel = ((objet.data.tel_num == null) ? "" : objet.data.tel_num)
    //    var mobile = ((objet.data.mob_num == null) ? "" : objet.data.mob_num)
    //    if (tel.length > 0 || mobile.length > 0) {
    //        var $DivAdr = $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'></div>").appendTo($Div)
    //        if (tel.length > 0) {
    //            var icon = $("<i class='fas fa-phone'/>")
    //            if (icon) icon.appendTo($DivAdr).css({ "color": theme.backgroundcolorAccent, display: "inline-block", "margin-right": "2px", "opacity": "0.6" })
    //            $("<span style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + tel + "</span>").appendTo($DivAdr)
    //        }
    //        if (mobile.length > 0) {
    //            var icon = $("<i class='fas fa-mobile-alt'/>")
    //            if (icon) icon.appendTo($DivAdr).css({ "color": theme.backgroundcolorAccent, display: "inline-block", "margin-right": "2px", "opacity": "0.6", "margin-left": ((tel) ? "8px" : "0") })
    //            $("<span style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + mobile + "</span>").appendTo($DivAdr)
    //        }
    //    }
    //    var email = ((objet.data.adresse_email == null) ? "" : objet.data.adresse_email)
    //    var fonction = ((objet.data.fonction == null) ? "" : objet.data.fonction)
    //    if ((email != null && email.length > 0) || (fonction != null && fonction.length > 0)) {
    //        var $DivAdr = $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'></div>").appendTo($Div)
    //        if (email != null && email.length > 0) {
    //            var icon = $("<i class='fas fa-at'/>")
    //            if (icon) icon.appendTo($DivAdr).css({ "color": theme.backgroundcolorAccent, display: "inline-block", "margin-right": "2px", "opacity": "0.6" })
    //            $("<span style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + email + "</span>").appendTo($DivAdr)
    //        }
    //        if (fonction != null && fonction.length > 0) {
    //            var icon = $("<i class='fas fa-globe'/>")
    //            if (icon) icon.appendTo($DivAdr).css({ "color": theme.backgroundcolorAccent, display: "inline-block", "margin-right": "2px", "opacity": "0.6", "margin-left": ((email) ? "8px" : "0") })
    //            $("<span style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'>" + fonction + "</span>").appendTo($DivAdr)
    //        }
    //    }
    //    var dateDerCnx = objet.data.derniere_date_connexion
    //    var dateFinAbonn = objet.data.date_fin_abonnement
    //    if (dateDerCnx != null || dateFinAbonn != null) {
    //        var $DivAdr = $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'></div>").appendTo($Div)
    //        if (dateDerCnx != null) {
    //            var icon = $("<i class='fas fa-calendar'/>")
    //            if (icon) icon.appendTo($DivAdr).css({ "color": theme.backgroundcolorAccent, display: "inline-block", "margin-right": "2px", "opacity": "0.6" })
    //            $("<span style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' title='Dernière connexion:" + dateDerCnx.toFrenchDateTime() + "'><span class='dx-field-item-label-text'>Dernière connexion:</span>" + dateDerCnx.toDateIlya(false) + "</span>").appendTo($DivAdr)
    //        }
    //        var icon = $("<i class='fas fa-calendar'/>")
    //        if (icon) icon.appendTo($DivAdr).css({ "color": theme.backgroundcolorAccent, display: "inline-block", "margin-right": "2px", "opacity": "0.6", "margin-left": ((dateDerCnx) ? "8px" : "0") })
    //        if (dateFinAbonn != null) {
    //            $("<span style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' title='Date fin abonnement:" + dateFinAbonn.toFrenchDateTime() + "'><span class='dx-field-item-label-text'>Fin abonnement:</span>" + dateFinAbonn.toDateIlya(false) + "</span>").appendTo($DivAdr)
    //        } else {
    //            $("<span style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' title='Aucun abonnement'>Aucun abonnement</span>").appendTo($DivAdr)
    //        }
    //    }
    //    if (contentElement.closest(".awsm-timeline-content").length > 0) $("<div style='position:absolute;font-size:80%;opacity:0.5;bottom:1px;right:2px;' title='" + objet.data.dcr.toFrenchDateTime() + "'>Créé " + objet.data.dcr.toDateIlya(true) + "</div>").appendTo(contentElement.parent().parent().parent().parent().parent());
    //}
    //this.itemTemplateVirtualGridFixedLigne = function (contentElement, option) {
    //    contentElement.empty()
    //    contentElement.css("font-size", "11px")
    //    if (typeof option == "undefined") option = {}
    //    if (typeof option.height == 'undefined') option.height = 30
    //    contentElement.css({ position: "relative" })

    //    var $Table = $("<table style='width:100%;table-layout: fixed;'/>").appendTo(contentElement)
    //    var $Tr = $("<tr style='white-space:nowrap;'/>").appendTo($Table)
    //    var $Td = $("<td style='width:" + option.height + "px'/>").appendTo($Tr)
    //    var opt = {
    //        bddCtrl: Me.objet.bddRef,
    //        data: Me.data,
    //        size: 20,
    //        searchStringImageWeb: "",
    //        allowClick: option.allowClickImage
    //    }
    //    //if (typeof option.onClickImage != 'undefined') opt.onClick = option.onClickImage
    //    var dxImageObjet = $("<div style=''/>").appendTo($Td).dxCtrlImageData(opt).dxCtrlImageData("instance")

    //    var $Td = $("<td style='width:16px;font-variant:small-caps;font-weight:bold;overflow-x:hidden;text-overflow:ellipsis;'></td>").appendTo($Tr)
    //    Me.mGetIcone().css({ "color": theme.backgroundcolorAccent, display: "inline-block", "margin-right": "2px", "font-size": "75%" }).appendTo($Td)
    //    var $Td = $("<td style='width:35%;font-variant:small-caps;font-weight:bold;overflow-x:hidden;text-overflow:ellipsis;font-size:130%;'></td>").appendTo($Tr)
    //    $("<span>" + Me.mGetLib1() + "</span>").appendTo($Td)

    //    var $Td = $("<td style='width:15%;overflow-x:hidden;text-overflow:ellipsis;'></td>").appendTo($Tr)
    //    var adr = ((objet.data.nom == null) ? "" : objet.data.nom) & " " & ((objet.data.prenom == null) ? "" : objet.data.prenom)
    //    if (adr.length > 0) {
    //        $Td.text(adr)
    //        $Td.attr("title", adr)
    //    }

    //    var $TdTel = $("<td style='width:18%;overflow-x:hidden;text-overflow:ellipsis;'></td>").appendTo($Tr)
    //    var $TdMob = $("<td style='width:17%;overflow-x:hidden;text-overflow:ellipsis;'></td>").appendTo($Tr)

    //    var tel = ((objet.data.tel_sms == null) ? "" : objet.data.tel_sms)
    //    var mobile = ((objet.data.mob_sms == null) ? "" : objet.data.mob_sms)
    //    if (tel.length > 0 || mobile.length > 0) {
    //        if (tel.length > 0) {
    //            $TdTel.text(tel)
    //            $TdTel.attr("title", tel)
    //        }
    //        if (mobile.length > 0) {
    //            var obj = Me.objet.bddRef.getObjet(mobile)
    //            $TdMob.text(mobile)
    //            $TdMob.attr("title", mobile)
    //        }
    //    }

    //    var $TdEma = $("<td style='width:15%;overflow-x:hidden;text-overflow:ellipsis;'></td>").appendTo($Tr)
    //    var $TdSite = $("<td style='width:15%;overflow-x:hidden;text-overflow:ellipsis;'></td>").appendTo($Tr)

    //    var email = ((objet.data.adresse_email == null) ? "" : objet.data.adresse_email)
    //    var fonction = ((objet.data.fonction == null) ? "" : objet.data.fonction)
    //    if ((email != null && email.length > 0) || (site != null && site.length > 0)) {
    //        if (email != null && email.length > 0) {
    //            $TdEma.text(email)
    //            $TdEma.attr("title", email)
    //        }
    //        if (fonction != null && fonction.length > 0) {
    //            $TdSite.text(fonction)
    //            $TdSite.attr("title", fonction)
    //        }
    //    }
    //}

    this.mGetDataCompteClient = function () {
        return Me.objet.bddRef.getObjet("compte_client", objet.data.id_compte_client).data
    }

    this.mGetTelephoneMiseEnForme = function () {
        if (objet.data.tel_sms != null && objet.data.tel_sms.length > 0) {
            var indicatif = parametre.lstIndicatifTel.filter(function (o) { return o.code == objet.data.tel_code_pays })[0]
            return indicatif.dial_code + " " + msAddCaractereTel(objet.data.tel_sms, ".")
        } else { return "" }
    }

    this.mGetMobileMiseEnForme = function () {
        if (objet.data.mob_sms != null && objet.data.mob_sms.length > 0) {
            var indicatif = parametre.lstIndicatifTel.filter(function (o) { return o.code == objet.data.mob_code_pays })[0]
            return indicatif.dial_code + " " + msAddCaractereTel(objet.data.mob_sms, ".")
        } else { return "" }
    }

    this.mGetAdresseEmailDefaut = function () {
        return objet.data.adresse_email
    }
    this.mGetSiteDefaut = function () {
        return ""
    }

    this.mGetAdrPostaleMiseEnForme = function () {
        return ""
    }

    this.mAddTelMobileSiVide = function (dataTel) {
        if (dataTel != null && dataTel.tel_number.length > 0) {
            objet.data.mob_code_pays = dataTel.tel_code_pays
            objet.data.mob_number = dataTel.tel_number
            objet.data.mob_complet = dataTel.tel_complet
            objet.data.mob_sms = dataTel.tel_sms
            objet.data.mob_error = dataTel.tel_error
            objet.data.mob_num_type = dataTel.tel_num_type
            objet.mSave()
        }
    }

    //#region CREATION COLUMN DXDATAGRID 
    this.mGetColumnDataGrid = function (lstCol, dxVirtualGrid) {
        //nom & prenom
        var col = {
            caption: "Nom & prénom",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if ((obj.data.nom == null && obj.data.prenom == null) || (obj.data.nom.length == 0 && obj.data.prenom.length == 0)) {
                    return "(vide)"
                } else { return obj.data.nom + ((obj.data.nom != null & obj.data.nom.length > 0 && obj.data.prenom != null && obj.data.prenom.length > 0) ? " " : "") + obj.data.prenom }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if ((obj.data.nom == null && obj.data.prenom == null) || (obj.data.nom.length == 0 && obj.data.prenom.length == 0)) {
                    container.html("<span style='opacity:0.1;text-decoration:line-through;'>(vide)</span>")
                } else {
                    container.text(obj.data.nom + ((obj.data.nom != null & obj.data.nom.length > 0 && obj.data.prenom != null && obj.data.prenom.length > 0) ? " " : "") + obj.data.prenom)
                }
            }
        }
        lstCol.push(col)
        //adresse_email
        var col = {
            caption: "Adresse email",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (typeof obj.data.adresse_email == 'undefined' || obj.data.adresse_email == null || obj.data.adresse_email.length == 0) { return "(aucun email)" }
                else { return obj.data.adresse_email }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (typeof obj.data.adresse_email == 'undefined' || obj.data.adresse_email == null || obj.data.adresse_email.length == 0) {
                    container.html("<span style='opacity:0.1;text-decoration:line-through;'>email</span>")
                }
                else { container.html("<u>" + obj.data.adresse_email + "</u>") }
            }
        }
        lstCol.push(col)
        //tel_code_pays && tel_num
        var col = {
            caption: "Téléphone",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                var tel = new cTelephone(obj.data.tel_code_pays, obj.data.tel_sms)
                if (!tel.hasValue()) { return "(aucun téléphone)" }
                else { return tel.mGetValueMiseEnForme() }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                var tel = new cTelephone(obj.data.tel_code_pays, obj.data.tel_sms)
                if (!tel.hasValue()) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>téléphone</span>") }
                else { container.html("" + tel.mGetValueMiseEnForme() + "") }
            }
        }
        lstCol.push(col)
        //mob_code_pays && mob_sms
        var col = {
            caption: "Mobile",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                var tel = new cTelephone(obj.data.mob_code_pays, obj.data.mob_sms)
                if (!tel.hasValue()) { return "(aucun mobile)" }
                else { return tel.mGetValueMiseEnForme() }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                var tel = new cTelephone(obj.data.mob_code_pays, obj.data.mob_sms)
                if (!tel.hasValue()) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>mobile</span>") }
                else { container.html("" + tel.mGetValueMiseEnForme() + "") }
            }
        }
        lstCol.push(col)
        //fonction
        var col = {
            caption: "Fonction",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.fonction == null || obj.data.fonction.length == 0) { return "(vide)" }
                else { return obj.data.fonction }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.fonction == null || obj.data.fonction.length == 0) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>(vide)</span>") }
                else { container.text(obj.data.fonction) }
            }
        }
        lstCol.push(col)
        //date_abandon
        var col = {
            caption: "Date abandon",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.date_abandon == null) { return "ACTIF" }
                else { return new Date(obj.data.date_abandon) }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.date_abandon == null) { container.html("<span>ACTIF</span>") }
                else { container.text(obj.data.date_abandon.toFrenchDateTime()) }
            }
        }
        lstCol.push(col)
        //administrateur
        var col = {
            caption: "Administrateur",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.administrateur == "0") { return false }
                else { return true }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.administrateur == "0") { container.text("NON") }
                else { container.text("OUI") }
            }
        }
        lstCol.push(col)
        //derniere_date_connexion
        var col = {
            caption: "Dernière date CNX",
            allowHiding: true,
            visible: false,
            allowResizing: true,
            allowGrouping: true,
            showWhenGrouped: true,
            allowSorting: true,
            calculateCellValue: function (rowData) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.derniere_date_connexion == null) { return "(vide)" }
                else { return new Date(obj.data.derniere_date_connexion) }
            },
            calculateGroupValue: function (rowData) { this.calculateCellValue(rowData) },
            calculateSortValue: function (rowData) { this.calculateCellValue(rowData) },
            cellTemplate: function (container, options) {
                var obj = dxVirtualGrid.mGetObjetStrCon(rowData)
                if (obj.data.derniere_date_connexion == null) { container.html("<span style='opacity:0.1;text-decoration:line-through;'>(vide)</span>") }
                else { container.text(obj.data.derniere_date_connexion.toFrenchDateTime()) }
            }
        }
        lstCol.push(col)
    }
    //#endregion CREATION COLUMN DXDATAGRID

}